import { ClockIcon as PhosphorClockIcon } from "@phosphor-icons/react/dist/ssr/Clock";

import { createAppIcon } from "@/components/createAppIcon";

export const ScheduleIcon = /* @__PURE__ */ createAppIcon(PhosphorClockIcon);
